/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as OrdersTypes from './orders-types'

export type EmployeeLoginAuditLog = {
	type: 'EMPLOYEE_LOGIN'
	employeeId: string
}
export type EmployeeLogoutAuditLog = {
	type: 'EMPLOYEE_LOGOUT'
	employeeId: string
}
export type DeleteLineItemAuditLog = {
	type: 'DELETE_LINE_ITEM'
	employeeId: string
}
export type OpenCashDrawerAuditLog = {
	type: 'OPEN_CASH_DRAWER'
	employeeId: string
}
export type OpenCashDrawerManuallyAuditLog = {
	type: 'OPEN_CASH_DRAWER_MANUALLY'
	employeeId: string
}
export type ReceiptPrintedAuditLog = {
	type: 'RECEIPT_PRINTED'
	employeeId?: string
	orderUuid: string
}
export type SystemStartAuditLog = {
	type: 'SYSTEM_START'
}
export type SystemShutdownAuditLog = {
	type: 'SYSTEM_SHUTDOWN'
}
export const PromotionActionType = {
	AddLoyaltyCardToWallet: 'ADD_LOYALTY_CARD_TO_WALLET',
	LoyaltyCardInfo: 'LOYALTY_CARD_INFO'
} as const
export type PromotionActionTypeType = (typeof PromotionActionType)[keyof typeof PromotionActionType]
export const PromotionType = {
	Banner: 'BANNER',
	Modal: 'MODAL',
	List: 'LIST',
	Separator: 'SEPARATOR'
} as const
export type PromotionTypeType = (typeof PromotionType)[keyof typeof PromotionType]
export type PromotionImage = {
	url: string
	width: number
	height: number
	maxWidthPercent?: number
	maxHeightPercent?: number
}
export type PromotionBanner =
	| {
			type: 'IMAGE'
			image: PromotionImage
	  }
	| {
			type: 'TEXT_WITH_BACKGROUND'
			text: string
			containerClassName?: string
			aspectRatio?: number
			textClassName?: string
	  }
export const PromotionLinkType = {
	Browser: 'BROWSER',
	Image: 'IMAGE',
	DeepLink: 'DEEP_LINK',
	Custom: 'CUSTOM'
} as const
export type PromotionLinkTypeType = (typeof PromotionLinkType)[keyof typeof PromotionLinkType]
export type Promotion = {
	uuid: string
	title?: string
	showMoreEnabled?: boolean
	showSeparator?: boolean
	classNames?: {
		top?: string
		bottom?: string
		left?: string
		right?: string
	}
	action?: PromotionActionTypeType
} & (
	| {
			type: 'BANNER'
			banner: PromotionBanner
			link?:
				| {
						type: 'BROWSER'
						url: string
				  }
				| {
						type: 'IMAGE'
						url: string
				  }
				| {
						type: 'DEEP_LINK'
						url: string
				  }
				| {
						type: 'CUSTOM'
						data: any
				  }
	  }
	| {
			type: 'MODAL'
			banner: PromotionBanner
			content: (
				| {
						type: 'IMAGE'
						image: PromotionImage
				  }
				| {
						type: 'TEXT_WITH_BACKGROUND'
						text: string
						aspectRatio?: number
						className?: string
						containerClassName?: string
						textClassName?: string
				  }
				| {
						type: 'TEXT'
						text: string
						className?: string
				  }
			)[]
	  }
	| {
			type: 'LIST'
			thumbnails: {
				containerAspectRatio?: number
				contentContainerClassName?: string
				itemAspectRatio?: number
				items: {
					url: string
					width: number
					height: number
					link?:
						| {
								type: 'BROWSER'
								url: string
						  }
						| {
								type: 'IMAGE'
								url: string
						  }
						| {
								type: 'DEEP_LINK'
								url: string
						  }
						| {
								type: 'CUSTOM'
								data: any
						  }
				}[]
			}
			content: PromotionImage[]
	  }
	| {
			type: 'SEPARATOR'
			containerClassName?: string
			className?: string
	  }
)
export type SalesChannel = {
	uuid: string
	name: string
	currencyCode: string
	checkoutCode?: string
	bagProductGroup?: string
	paymentProviders: OrdersTypes.PaymentProviderConfig[]
	pickListProductGroups?: {
		uuid: string
		name: string
	}[]
	location?: {
		latitude: number
		longitude: number
	}
}

export const zEmployeeLoginAuditLog = z.object({
	type: z.enum(['EMPLOYEE_LOGIN']),
	employeeId: z.string()
})
export const zEmployeeLogoutAuditLog = z.object({
	type: z.enum(['EMPLOYEE_LOGOUT']),
	employeeId: z.string()
})
export const zDeleteLineItemAuditLog = z.object({
	type: z.enum(['DELETE_LINE_ITEM']),
	employeeId: z.string()
})
export const zOpenCashDrawerAuditLog = z.object({
	type: z.enum(['OPEN_CASH_DRAWER']),
	employeeId: z.string()
})
export const zOpenCashDrawerManuallyAuditLog = z.object({
	type: z.enum(['OPEN_CASH_DRAWER_MANUALLY']),
	employeeId: z.string()
})
export const zReceiptPrintedAuditLog = z.object({
	type: z.enum(['RECEIPT_PRINTED']),
	employeeId: z.string().optional(),
	orderUuid: z.string()
})
export const zSystemStartAuditLog = z.object({
	type: z.enum(['SYSTEM_START'])
})
export const zSystemShutdownAuditLog = z.object({
	type: z.enum(['SYSTEM_SHUTDOWN'])
})
export const zPromotionActionType = z.enum(['ADD_LOYALTY_CARD_TO_WALLET', 'LOYALTY_CARD_INFO'])
export const zPromotionType = z.enum(['BANNER', 'MODAL', 'LIST', 'SEPARATOR'])
export const zPromotionImage = z.object({
	url: z.string(),
	width: z.number(),
	height: z.number(),
	maxWidthPercent: z.number().optional(),
	maxHeightPercent: z.number().optional()
})
export const zPromotionBanner = z.union([
	z.object({
		type: z.enum(['IMAGE']),
		image: zPromotionImage
	}),
	z.object({
		type: z.enum(['TEXT_WITH_BACKGROUND']),
		text: z.string(),
		containerClassName: z.string().optional(),
		aspectRatio: z.number().optional(),
		textClassName: z.string().optional()
	})
])
export const zPromotionLinkType = z.enum(['BROWSER', 'IMAGE', 'DEEP_LINK', 'CUSTOM'])
export const zPromotion = z.intersection(
	z.object({
		uuid: z.string(),
		title: z.string().optional(),
		showMoreEnabled: z.boolean().optional(),
		showSeparator: z.boolean().optional(),
		classNames: z
			.object({
				top: z.string().optional(),
				bottom: z.string().optional(),
				left: z.string().optional(),
				right: z.string().optional()
			})
			.optional(),
		action: zPromotionActionType.optional()
	}),
	z.discriminatedUnion('type', [
		z.object({
			type: z.enum(['BANNER']),
			banner: zPromotionBanner,
			link: z
				.union([
					z.object({
						type: z.enum(['BROWSER']),
						url: z.string()
					}),
					z.object({
						type: z.enum(['IMAGE']),
						url: z.string()
					}),
					z.object({
						type: z.enum(['DEEP_LINK']),
						url: z.string()
					}),
					z.object({
						type: z.enum(['CUSTOM']),
						data: z.any()
					})
				])
				.optional()
				.nullable()
		}),
		z.object({
			type: z.enum(['MODAL']),
			banner: zPromotionBanner,
			content: z.array(
				z.union([
					z.object({
						type: z.enum(['IMAGE']),
						image: zPromotionImage
					}),
					z.object({
						type: z.enum(['TEXT_WITH_BACKGROUND']),
						text: z.string(),
						aspectRatio: z.number().optional(),
						className: z.string().optional(),
						containerClassName: z.string().optional(),
						textClassName: z.string().optional()
					}),
					z.object({
						type: z.enum(['TEXT']),
						text: z.string(),
						className: z.string().optional()
					})
				])
			)
		}),
		z.object({
			type: z.enum(['LIST']),
			thumbnails: z.object({
				containerAspectRatio: z.number().optional(),
				contentContainerClassName: z.string().optional(),
				itemAspectRatio: z.number().optional(),
				items: z.array(
					z.object({
						url: z.string(),
						width: z.number(),
						height: z.number(),
						link: z
							.union([
								z.object({
									type: z.enum(['BROWSER']),
									url: z.string()
								}),
								z.object({
									type: z.enum(['IMAGE']),
									url: z.string()
								}),
								z.object({
									type: z.enum(['DEEP_LINK']),
									url: z.string()
								}),
								z.object({
									type: z.enum(['CUSTOM']),
									data: z.any()
								})
							])
							.optional()
							.nullable()
					})
				)
			}),
			content: z.array(zPromotionImage)
		}),
		z.object({
			type: z.enum(['SEPARATOR']),
			containerClassName: z.string().optional(),
			className: z.string().optional()
		})
	])
)
export const zSalesChannel = z.object({
	uuid: z.string(),
	name: z.string(),
	currencyCode: z.string(),
	checkoutCode: z.string().optional(),
	bagProductGroup: z.string().optional(),
	paymentProviders: z.array(OrdersTypes.zPaymentProviderConfig),
	pickListProductGroups: z
		.array(
			z.object({
				uuid: z.string(),
				name: z.string()
			})
		)
		.optional(),
	location: z
		.object({
			latitude: z.number(),
			longitude: z.number()
		})
		.optional()
})
